const Dashboard = () => {
  return <div className="mt-4">Dashboard content</div>;
};

export default Dashboard;
